export const FETCH_POINT_BALANCE_REQUEST = "FETCH_POINT_BALANCE_REQUEST";
export const FETCH_POINT_BALANCE_SUCCESS = "FETCH_POINT_BALANCE_SUCCESS";
export const FETCH_POINT_BALANCE_FAILURE = "FETCH_POINT_BALANCE_FAILURE";
export const FETCH_POINT_BALANCE_CLEAR = "FETCH_POINT_BALANCE_CLEAR"